import { useMemo } from 'react';
import isNil from 'lodash-es/isNil';

import { Plan } from '~/src/common/brooklyn/plan-utils';
import { TPlan, useMembershipPlans } from '~/src/common/brooklyn/plans';

function getErrorMsg({
  error,
  plans,
  targetPlan,
}: {
  error: ReturnType<typeof useMembershipPlans>['error'];
  plans: ReturnType<typeof useMembershipPlans>['plans'];
  targetPlan: TPlan | null;
}) {
  if (error) {
    return error.message;
  }
  if (!plans) {
    return 'Error: missing plans data';
  }
  if (isNil(targetPlan)) {
    return 'Error: missing plan data';
  }
  return null;
}

export const usePlan = (
  extractPlan: (plans: ReturnType<typeof useMembershipPlans>['plans']) => TPlan | null,
) => {
  const { loading, error: membershipPlansError, plans } = useMembershipPlans();

  const planDetails = extractPlan(plans);
  const error = getErrorMsg({ error: membershipPlansError, plans, targetPlan: planDetails });

  const plan = useMemo(() => (isNil(planDetails) ? null : new Plan(planDetails)), [planDetails]);

  const result = useMemo(() => {
    return {
      loading,
      error,
      plan,
    };
  }, [error, loading, plan]);
  return result;
};
